// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"649302fb","551":"7dd49b25","617":"c4a98c31","640":"21c272b2","732":"db729a41","842":"4b825ed9","851":"992003be","977":"3e20ef7e"}[chunkId] + ".chunk.js";
};